/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_AssignInputs */

const vi_reconcile_assign = /** @type {(inputs: Reconcile_AssignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gán vào đơn`)
};

/**

* @param {Reconcile_AssignInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_assign = /** @type {((inputs?: Reconcile_AssignInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_AssignInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_assign(inputs)
});